<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <g fill="currentColor">
      <path
        d="M12 2.2c-1.3 0-2.6.3-3.8.7-1.1.5-2.2 1.2-3.1 2.2-1 .9-1.7 2-2.2 3.1-.5 1.2-.7 2.5-.7 3.8s.3 2.6.7 3.8S4.1 18.1 5 19c.9.9 2 1.6 3.2 2.1 1.2.5 2.5.7 3.8.7 2.6 0 5.1-1 6.9-2.9 1.8-1.8 2.9-4.3 2.9-6.9s-1-5.1-2.9-6.9c-1.8-1.9-4.3-2.9-6.9-2.9zM0 12C0 5.4 5.4 0 12 0s12 5.4 12 12-5.4 12-12 12S0 18.6 0 12z"
      />
      <path
        d="M12.3 5.5c.3 0 .6.1.8.3.2.2.3.5.3.8V12c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3s-.6-.1-.8-.3c-.2-.2-.3-.5-.3-.8V6.5c0-.3.1-.6.3-.8.2-.1.5-.2.8-.2zm1.3 10.6c0 .4-.1.7-.4 1-.3.3-.6.4-1 .4s-.7-.1-1-.4c-.3-.3-.4-.6-.4-1s.1-.7.4-1c.3-.3.6-.4 1-.4s.7.1 1 .4c.3.3.4.6.4 1z"
      />
    </g>
  </svg>
</template>
